import { connect } from 'react-redux';

import PrivacyPolicy from '../components/pages/privacy-policy';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const PrivacyPolicyConnector = connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);

export default PrivacyPolicyConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/privacy-policy-connector.js
 **/